import type { Stream } from "../../lib/api/types";
import { displayState, STATE_TONE } from "../../lib/stream-status";
import { Pill } from "../../components/ui/Pill";

export function StatusPill({ stream }: { stream: Pick<Stream, "actualState" | "desiredState" | "attempt"> }) {
  const s = displayState(stream);
  const busy = s === "STARTING" || s === "PENDING" || s === "STOPPING" || s === "RETRYING";
  return (
    <Pill tone={STATE_TONE[s]} pulse={busy} live={s === "RUNNING"}>
      {s}{s === "RETRYING" && stream.attempt > 0 ? ` #${stream.attempt}` : ""}
    </Pill>
  );
}
